module.exports = __webpack_public_path__ + "img/sample-room-2.3b89cfae.png";